import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Button, MenuItem, Select, Stack, TextField, Typography, FormLabel, Dialog, DialogTitle, DialogContent, IconButton, Box, CircularProgress } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import InputBase from "@mui/material/InputBase";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { format, parseISO } from "date-fns";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import CloseIcon from '@mui/icons-material/Close';
import SignatureSelection from "./SignatureSelection";
import { baseURL } from "../Constant";
import WelcomeNameContainer from "../LaunchComponent/WelcomeNameContainer";
import { handleCertificateLoading, handleGenerateCertificate } from "../Redux/Certificate";
import { fetchCampaignsData, handleCampainIDSelection, resetSubmissionButton } from "../Redux/Mailer";
import DataDisplay from "./dataDisplay";
import ApprovedTemplate from "./ApprovedTemplate";
import FilePreviewAndSubmit from "./FilePreviewAndSubmit";
import LogoSelection from "./LogoSelection";
import "./certificateForm.css";
const WhiteBorderTextField = styled(TextField)(({
  theme
}) => ({
  " & label.Mui-focused": {
    color: " #a804ff"
  },
  " & .MuiOutlinedInput-root": {
    padding: "8.5px 12px  !important",
    "&.Mui-focused fieldset": {
      borderColor: "#a814ff",
      borderWidth: "1px"
    }
  },
  "& .MuiInputBase-input": {
    // Use the system font instead of the default Roboto font.
    fontFamily: ["Graphik-Regular"],
    fontSize: "14px"
  },
  "& .MuiInputBase-root-MuiOutlinedInput-root": {
    padding: "1px 2px !important"
  }
}));
const CustomRadio = styled(Radio)(({
  theme
}) => ({
  "&.Mui-checked": {
    color: "#9c27b0" // Purple for the checked state
  },
  "& .MuiSvgIcon-root": {
    fontSize: "1.5rem" // Custom icon size
  },
  "&:hover": {
    backgroundColor: "rgba(156, 39, 176, 0.08)" // Optional hover effect
  }
}));
const BootstrapInput = styled(InputBase)(({
  theme
}) => ({
  "label + &": {
    marginTop: theme.spacing(3)
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 14,
    padding: "9px 26px 9px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: ["Graphik-Regular"]
  }
}));
const CertificateForm = ({
  mailerChild,
  setMailerChild,
  setMailerParent,
  mailerParent
}) => {
  const HtmlTooltip = styled(({
    className,
    ...props
  }) => <Tooltip {...props} classes={{
    popper: className
  }} />)(({
    theme
  }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9"
    }
  }));
  const [programNameCertificate, setprogramNameCertificate] = useState("");
  const [campaign, setCampaign] = useState(0);
  const campaignList = useSelector(state => state.model.campaignList);
  const options = campaignList.message !== "No campaign for this user." && campaignList.length > 0 ? campaignList.map(item => ({
    id: item.id,
    name: item.name
  })) : [];
  const [categoryCertificate, setCategoryCertificate] = useState("");
  const [programDateCertificate, setProgramDateCertificate] = useState(null);
  const [isMailGeneratedCertificate, setIsMailGeneratedCertificate] = useState("init");
  const [keyMessageCertificate, setKeyMessageCertificate] = useState("");
  const [isCertificateMailGenerationClicked, setIsCertificateGenerationClicked] = React.useState(false);
  const [isCertificateNavigatedToForm, setIsCertificateNavigatedToForm] = useState(false);
  const handleRadioChange = e => {
    setCategoryName(e.target.value);
    setValue("");
    handleRadioChangeReset();
    dispatch(fetchCampaignsData(e.target.value));
  };
  const [categoryName, setCategoryName] = useState("Program");
  const [certificateType, setCertificateType] = useState('pre-approved');
  const [templatesList, setTemplatesList] = useState([]);
  const [template, setTemplate] = useState("");
  const [signatures, setSignatures] = useState([]);
  const [selectedLogos, setSelectedLogos] = useState([]);
  const [selectedSignature, setSelectedSignature] = useState([]);
  const [pptxLink, setPptLink] = useState("");
  const [certificateLoading, setCertificateLoading] = useState(false);
  const [templateModalOpen, setTemplateModalOpen] = useState(false);
  const [templateSecureUrl, setTemplateSecureUrl] = useState('');
  const [templateImgLoading, setTemplateImgLoading] = useState(false);
  const userID = useSelector(state => state.model.userID);
  const dispatch = useDispatch();
  const handleCategory = event => {
    setCategoryCertificate(event.target.value);
    setIsMailGeneratedCertificate("init");
    getTemplates(event.target.value);
    setTemplate("");
  };
  const programCategories = ["Participation", "Completion", "Achievement"];
  const programCategoriesEvent = ["Participation", "Achievement"];
  const programCategoriesTool = ["Achievement"];
  const handleCertificateType = event => {
    setCertificateType(event.target.value);
  };
  async function getTemplates(category) {
    const res = await axios.get(`${baseURL}/pptx/templates?category=${category}`);
    setTemplatesList(res.data.data);
  }
  async function getSignatures() {
    const res = await axios.get(`${baseURL}/pptx/signatures`);
    setSignatures(res.data.data);
  }
  async function getSelectedTemplateImageUrl(selectedTemplate, category) {
    try {
      const data = {
        template: selectedTemplate,
        category: category
      };
      const config = {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json"
        }
      };
      const res = await axios.post(`${baseURL}/pptx/templateImageUrl`, data, config);
      setTemplateSecureUrl(res.data.fileUrl);
      setTemplateImgLoading(false);
    } catch (error) {
      console.log("Failed to fetch template image url: ", error.message);
    }
  }
  function handleTemplate(e) {
    setTemplateImgLoading(true);
    setTemplate(e.target.value);
    getSelectedTemplateImageUrl(e.target.value, categoryCertificate);
    setTemplateModalOpen(true);
    getSignatures();
  }
  const handleCertificateMailGeneration = () => {
    setIsCertificateGenerationClicked(true);
    let values = {
      programNameCertificate: programNameCertificate,
      programDateCertificate: programDateCertificate,
      keyMessageCertificate: keyMessageCertificate,
      currentContent: "",
      sessionID: localStorage.getItem("sessionId"),
      categoryNameCertificate: categoryCertificate,
      categoryName: categoryName
    };
    dispatch(handleGenerateCertificate(values));
  };
  const handleReset = () => {
    dispatch(resetSubmissionButton());
    setMailerChild("");
    setMailerParent("");
    setCategoryName("Program");
    setProgramDateCertificate("");
    setCategoryCertificate("");
    setKeyMessageCertificate();
  };
  const handleCampaignID = val => {
    if (val) {
      setCampaign(val.id);
      let campaignID = val.id;
      let data = campaignList.filter(val => val.id == campaignID);
      setprogramNameCertificate(data[0].name);
      const endDateItem = data[0].selectedItems.filter(val => val.title == "Learning Journey End");
      let learningJourneyEnd;
      if (endDateItem.length != 0) {
        learningJourneyEnd = format(parseISO(endDateItem[0].date), "yyyy-MM-dd");
      } else {
        learningJourneyEnd = "";
      }
      setProgramDateCertificate(learningJourneyEnd);
      dispatch(handleCampainIDSelection(campaignID));
    }
  };
  useEffect(() => {
    dispatch(fetchCampaignsData(categoryCertificate));
  }, []);
  const [value, setValue] = React.useState(null);
  const handleChange = event => {
    if (event.target.value == "no") {
      setCampaign(0);
      dispatch(handleCampainIDSelection(0));
    }
    handleRadioChangeReset();
    setValue(event.target.value);
  };
  const handleRadioChangeReset = () => {
    setIsCertificateNavigatedToForm(false);
    setIsMailGeneratedCertificate("init");
    dispatch(resetSubmissionButton());
    setCampaign(0);
    setProgramDateCertificate("");
    setCategoryCertificate("");
    setKeyMessageCertificate();
    setprogramNameCertificate("");
  };
  return <>
   {!isCertificateMailGenerationClicked ? <Stack sx={{
      width: "100%"
    }} spacing={10}>
     <Stack sx={{
        height: "20px"
      }}>
      <WelcomeNameContainer currentComp="E-Certificate" />
     </Stack>
     <Stack spacing={4} sx={{
        paddingLeft: "30px",
        marginTop: "60px !important"
      }}>
      <div className="mailer-form-categories-section">
       <label class="mailer-form-categories-container">
        <span className="mailer-form-categories-text">Learning Program</span>
        <input type="radio" checked={categoryName === "Program"} value="Program" name="radio-category" onChange={handleRadioChange} />
        <span class="mailer-form-categories-checkmark"></span>
       </label>
       <label class="mailer-form-categories-container">
        <span className="mailer-form-categories-text">Event</span>
        <input type="radio" checked={categoryName === "Event"} value="Event" name="radio-category" onChange={handleRadioChange} />
        <span class="mailer-form-categories-checkmark"></span>
       </label>
       <label class="mailer-form-categories-container">
        <span className="mailer-form-categories-text">Microsite/Tool/Platform</span>
        <input type="radio" checked={categoryName === "Microsite/Tool/Platform"} value="Microsite/Tool/Platform" name="radio-category" onChange={handleRadioChange} />
        <span class="mailer-form-categories-checkmark"></span>
       </label>

       <label class="mailer-form-categories-container">
        <span className="mailer-form-categories-text">Webinar</span>
        <input type="radio" checked={categoryName === "Webinar"} value="Webinar" name="radio-category" onChange={handleRadioChange} />
        <span class="mailer-form-categories-checkmark"></span>
       </label>
      </div>
      <Stack direction={"row"} sx={{
          alignItems: "flex-start"
        }} spacing={2}>
       <Stack direction={"row"} sx={{
            alignItems: "flex-start"
          }} spacing={2}>
        <Stack direction={"column"}>
         <Typography>
          Is this communication part of any campaign?
          <span className="migrated-style-certificateform-251365-1">*</span>
         </Typography>
         <Typography>(If yes, select the campaign name)</Typography>
        </Stack>

        <FormControl>
         <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group" value={value} onChange={handleChange} sx={{
                paddingLeft: "20px"
              }}>
          <FormControlLabel value="yes" control={<CustomRadio icon={<RadioButtonUncheckedIcon className="migrated-style-certificateform-251365-2" />} // Empty circle when unchecked
                checkedIcon={<CheckCircleOutlineIcon className="migrated-style-certificateform-251365-3" />} // Checkmark inside circle when checked
                />} label="Yes" />
          <FormControlLabel value="no" control={<CustomRadio icon={<RadioButtonUncheckedIcon className="migrated-style-certificateform-251365-4" />} // Empty circle when unchecked
                checkedIcon={<CheckCircleOutlineIcon className="migrated-style-certificateform-251365-5" />} // Checkmark inside circle when checked
                />} label="No" />
         </RadioGroup>
        </FormControl>
       </Stack>
       {value == "yes" && <Stack direction={"row"} sx={{
            alignItems: "center"
          }} spacing={2}>
         <Typography>
          Select the campaign <span className="migrated-style-certificateform-251365-6">*</span>
         </Typography>
         <Stack sx={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              marginBottom: "10px",
              //  m: 1,
              width: 200
              //  mt: 3,
            }} direction={"row"} spacing={2}>
          {/* <Select value={campaign} onChange={handleCampaignID}>
           {campaignList.message != "No campaign for this user." &&
            campaignList.length > 0 &&
            campaignList.map((item, index) => (
             <MenuItem key={index + 1} value={item.id}>
              {item.name}
             </MenuItem>
            ))}
           </Select> */}
          <Autocomplete value={options.find(option => option.id === campaign) || null} onChange={(event, newValue) => {
                handleCampaignID(newValue);
              }} options={options} getOptionLabel={option => option.name || ""} ListboxProps={{
                style: {
                  maxHeight: "150px",
                  // Fixed height for the dropdown
                  overflowY: "auto" // Enable vertical scrolling
                }
              }} renderInput={params => <TextField sx={{
                "& .MuiOutlinedInput-root": {
                  padding: "2px !important"
                }
              }} {...params} variant="outlined" />} filterSelectedOptions={false} />
         </Stack>
        </Stack>}
      </Stack>
      <Stack spacing={0.5} sx={{
          marginTop: '18px !important'
        }}>
            <Stack direction={"row"} justifyContent={"space-between"}>           
                <FormControl className="migrated-style-certificateform-251365-7">
                    <FormLabel sx={{
                color: 'rgb(0 0 0 / 68%)',
                fontSize: "16px",
                fontFamily: "Graphik-Medium",
                gap: '100px'
              }} id="demo-controlled-radio-buttons-group">
                        Certificates:
                    </FormLabel>
                    <RadioGroup aria-labelledby="demo-controlled-radio-buttons-group" name="controlled-radio-buttons-group" value={certificateType} onChange={handleCertificateType} row>
                        <FormControlLabel value="pre-approved" control={<Radio />} label="Pre-approved" sx={{
                  color: 'black',
                  fontSize: "13px",
                  fontFamily: "Graphik-Medium"
                }} />
                        <FormControlLabel value="customize" control={<Radio />} label="Customize" sx={{
                  color: 'black',
                  fontSize: "13px",
                  fontFamily: "Graphik-Medium"
                }} />
                    </RadioGroup>
                </FormControl>
          </Stack>          
      </Stack>
      <Stack direction={"column"} spacing={2} alignItems={"center"}>
       <Grid container spacing={2}>
        <Grid item xs={3}>
         <Stack spacing={0.5}>
          <Stack direction={"row"} justifyContent={"space-between"}>
           <Typography sx={{
                    fontSize: "14px",
                    fontFamily: "Graphik-Medium"
                  }}>
            Name<span className="migrated-style-certificateform-251365-8">*</span>
           </Typography>
           <HtmlTooltip arrow title={<React.Fragment>
              {" "}
              {categoryName == "program" ? <p> Enter the program name </p> : categoryName == "event" ? <p> Enter the event name</p> : categoryName == "Microsite/Tool/Platform" ? <p> Enter the Microsite/Tool/Platform name</p> : <p> Enter the Webinar name</p>}
             </React.Fragment>}>
            <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-certificateform-251365-9"></img>
           </HtmlTooltip>
          </Stack>
          <WhiteBorderTextField placeholder={categoryName == "Program" ? "e.g: Java Full Stack" : categoryName == "Event" ? "e.g: Google Cloud Fusion Fest" : categoryName == "Webinar" ? "e.g: Azure Open AI Security" : "e.g: HMM Spark"} id="multiline" multiline InputLabelProps={{
                  shrink: false
                }} minRows={1} disabled={value == null || value == "yes" && campaign == 0 ? true : false}
                //  maxRows={2}
                InputProps={{
                  readOnly: value === "yes" && campaign != 0
                }} onChange={event => {
                  setprogramNameCertificate(event.target.value);
                  setIsMailGeneratedCertificate("init");
                }} fullWidth sx={{
                  fontFamily: "Graphik-Regular",
                  padding: "6px,10px"
                }} value={programNameCertificate} />
         </Stack>
        </Grid>
        <Grid item xs={3}>
         <Stack spacing={0.5}>
          <Stack direction={"row"} justifyContent={"space-between"}>
           <Typography sx={{
                    fontSize: "14px",
                    fontFamily: "Graphik-Medium"
                  }}>
            Category<span className="migrated-style-certificateform-251365-10">*</span>
           </Typography>
           <HtmlTooltip arrow title={<React.Fragment>Select category of e-certificate</React.Fragment>}>
            <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-certificateform-251365-11"></img>
           </HtmlTooltip>
          </Stack>
          <Stack sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginBottom: "10px",
                  m: 1,
                  width: "200",
                  mt: 3
                }} direction={"row"} spacing={2}>
           <Select input={<BootstrapInput />} value={categoryCertificate} onChange={handleCategory}
                  // MenuProps={MenuProps}
                  disabled={value == null || value == "yes" && campaign == 0 ? true : false}>
            {categoryName == "Program" ? programCategories.map((item, index) => <MenuItem key={index + 1} value={item}>
                 {item}
                </MenuItem>) : categoryName == "Microsite/Tool/Platform" ? programCategoriesTool.map((item, index) => <MenuItem key={index + 1} value={item}>
                 {item}
                </MenuItem>) : programCategoriesEvent.map((item, index) => <MenuItem key={index + 1} value={item}>
                 {item}
                </MenuItem>)}
           </Select>
          </Stack>
         </Stack>
        </Grid>
        <Grid item xs={3}>
         <Stack spacing={0.5}>
          <Stack direction={"row"} justifyContent={"space-between"}>
           <Typography sx={{
                    fontSize: "14px",
                    fontFamily: "Graphik-Medium"
                  }}>
            Date of Completion
           </Typography>
           <HtmlTooltip arrow title={<React.Fragment>Specify the completion date.</React.Fragment>}>
            <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-certificateform-251365-12"></img>
           </HtmlTooltip>
          </Stack>
          <input type="date" className="maindate migrated-style-certificateform-251365-13" onChange={event => {
                  setProgramDateCertificate(event.target.value);
                  setIsMailGeneratedCertificate("init");
                }} disabled={value == null || value == "yes" && campaign == 0 ? true : false} value={programDateCertificate} readOnly={value == "yes" && campaign != 0 && programDateCertificate != "" ? true : false} onKeyDown={e => e.preventDefault()} />
         </Stack>
        </Grid>
       </Grid>
       {certificateType === "customize" && <>
          <Grid container spacing={2}>
            <Grid item xs={6}>
            <Stack spacing={0.5}>
              <Stack direction={"row"} justifyContent={"space-between"}>
              <Typography sx={{
                      fontSize: "14px",
                      fontFamily: "Graphik-Medium"
                    }}>
                Key Message
              </Typography>
              <HtmlTooltip arrow title={<React.Fragment>
                  Provide a key message for the recipient (e.g., awarded for event
                  participation, winner, and runner-up if any quiz).{" "}
                </React.Fragment>}>
                <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-certificateform-251365-14"></img>
              </HtmlTooltip>
              </Stack>
              <WhiteBorderTextField placeholder={categoryName == "program" ? categoryCertificate == "Participation" ? "e.g: Certificate of Participation given for participating in a learning program." : categoryCertificate == "Completion" ? "e.g: Certificate of Completion given on successful completion of a learning program." : categoryCertificate == "Achievement" && "e.g: Certificate of Achievement given on exception performance or contribution in a learning program." : categoryName == "event" ? categoryCertificate == "Participation" ? "e.g:  Certificate of Participation given for participating in an event." : categoryCertificate == "Achievement" && "e.g: Certificate of Achievement given on exception performance or contribution in a learning program." : categoryName == "webinars" ? categoryCertificate == "Participation" ? "e.g: Certificate of Participation given for participating in a webinar." : categoryCertificate == "Achievement" && "e.g: Certificate of Achievement for an exceptional role in developing a microsite/tool/platform." : categoryName == "Microsite/Tool/Platform" ? categoryCertificate == "Achievement" && "e.g: Certificate of Achievement for an exceptional role in developing a microsite/tool/platform." : ""} id="outlined-multiline-flexible" multiline maxRows={3} minRows={3} disabled={value == null || value == "yes" && campaign == 0 ? true : false} onChange={event => {
                    setKeyMessageCertificate(event.target.value);
                    setIsMailGeneratedCertificate("init");
                  }} fullWidth sx={{
                    fontFamily: "Graphik-Regular",
                    padding: "6px,10px"
                  }} value={keyMessageCertificate} />
            </Stack>
            </Grid>
          </Grid>
          <Stack justifyContent={"center"} alignItems={"center"} direction={"row"} spacing={2}>
            {isCertificateNavigatedToForm && <Button sx={{
                border: "1px solid #d3d3d3",
                borderRadius: "5px",
                padding: "10px",
                width: "150px",
                alignItems: "center",
                width: "150px",
                background: "#fff",
                color: "#a814ff",
                textTransform: "none",
                fontFamily: "Graphik-Medium"
              }} onClick={() => {
                setIsCertificateGenerationClicked(true);
                setIsMailGeneratedCertificate("generateOutput");
              }}>
              Next
            </Button>}
            {programNameCertificate == "" || programCategories == null || programDateCertificate == null || isMailGeneratedCertificate !== "init" ? <Stack direction={"row"} spacing={1} sx={{
                border: "2px solid #8a2be2",
                borderRadius: "28px",
                padding: " 4px 0 4px 6px",
                width: "150px",
                alignItems: "center",
                width: "150px",
                pointerEvents: "none",
                opacity: " 0.4"
              }}>
              <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"} className="migrated-style-certificateform-251365-15"></img>
              <span className="migrated-style-certificateform-251365-16">Generate</span>
            </Stack> : <Stack direction={"row"} spacing={1} sx={{
                border: "2px solid #8a2be2",
                borderRadius: "28px",
                padding: " 4px 0 4px 6px",
                width: "150px",
                alignItems: "center",
                width: "150px",
                cursor: "pointer"
              }} onClick={() => {
                handleCertificateMailGeneration();
                setIsMailGeneratedCertificate("generateOutput");
                dispatch(handleCertificateLoading());
              }}>
              <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"} className="migrated-style-certificateform-251365-17"></img>

              <span className="migrated-style-certificateform-251365-18">Generate</span>
            </Stack>}
          </Stack>
        </>}
       {certificateType === "pre-approved" && <>
          <Grid container spacing={2}>
              <Grid item xs={6}>
                  <Stack spacing={0.5}>                    
                      <Typography sx={{
                    fontSize: "14px",
                    fontFamily: "Graphik-Medium"
                  }}>
                          Template<span className="migrated-style-certificateform-251365-19">*</span>
                      </Typography>                               
                      <Stack sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "3px",
                    justifyContent: "center",
                    alignItems: "center"
                  }}>
                          <Select input={<BootstrapInput />} value={template} onChange={handleTemplate} sx={{
                      width: "100%"
                    }}>                            
                              {templatesList.map((item, index) => <MenuItem key={index + 1} value={item.stored_filename}>
                                  {item.original_filename}
                                  </MenuItem>)}                            
                          </Select>                          
                      </Stack>
                  </Stack>
              </Grid>
              <Grid item xs={6}>
                  <Stack spacing={0.5}>                    
                    <Dialog open={templateModalOpen} onClose={() => {
                    setTemplateModalOpen(false);
                  }} maxWidth="sm" fullWidth={false} hideBackdrop PaperProps={{
                    sx: {
                      position: 'fixed',
                      bottom: 16,
                      right: 16,
                      m: 0
                    }
                  }}>
                      <DialogTitle sx={{
                      p: 0
                    }}>                        
                        <IconButton aria-label="close" onClick={() => {
                        setTemplateModalOpen(false);
                      }} sx={{
                        position: 'absolute',
                        right: 1,
                        top: 1
                      }}>
                          <CloseIcon />
                        </IconButton>
                      </DialogTitle>
                      <DialogContent sx={{
                      p: '0 !important'
                    }}>                                                                            
                        <Box sx={{
                        width: '450px',
                        height: '300px',
                        overflow: "hidden"
                      }}>                                                    
                          {templateImgLoading ? <CircularProgress sx={{
                          margin: '30% 45%'
                        }} /> : <img src={templateSecureUrl} width="100%" height="100%" />}
                        </Box>                                                
                      </DialogContent>
                    </Dialog>                          
                  </Stack>
              </Grid>
          </Grid>
          <Grid container spacing={2}>
              <Grid item xs={6}>
                  <Stack spacing={0.5}> 
                      <Stack direction={"row"} justifyContent={"space-between"}>
                        <Typography sx={{
                      fontSize: "14px",
                      fontFamily: "Graphik-Medium"
                    }}>
                          Additional Signature
                        </Typography>   
                        <HtmlTooltip arrow title={<React.Fragment>                            
                            <ol className="migrated-style-certificateform-251365-20">
                              <li className="migrated-style-certificateform-251365-21">Choose the signature to insert in the template.</li>
                              <li className="migrated-style-certificateform-251365-22">Review the order of the signature since the same will be added in the certificate template.</li>
                              <li className="migrated-style-certificateform-251365-23">If the order is not fine it can be shuffled by drag and drop.</li>
                            </ol>
                          </React.Fragment>}>
                          <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-certificateform-251365-24"></img>
                        </HtmlTooltip>
                      </Stack>                                                                                           
                      <SignatureSelection signatures={signatures} selectedSignatures={selectedSignature} setSelectedSignatures={setSelectedSignature} />
                  </Stack>
              </Grid>
          </Grid>
          <Grid container spacing={2}>
              <Grid item xs={6}>
                  <Stack spacing={0.5}>                                          
                      <Stack direction={"row"} justifyContent={"space-between"}>
                        <Typography sx={{
                      fontSize: "14px",
                      fontFamily: "Graphik-Medium"
                    }}>
                          Logo
                        </Typography>   
                        <HtmlTooltip arrow title={<React.Fragment>
                            <ol className="migrated-style-certificateform-251365-25">
                              <li className="migrated-style-certificateform-251365-26">Choose the logo to add in the certificate.</li>
                              <li className="migrated-style-certificateform-251365-27">Review the order of the logo and you can shuffle the order if required.</li>                              
                            </ol>                                                                                    
                          </React.Fragment>}>
                          <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-certificateform-251365-28"></img>
                        </HtmlTooltip>
                      </Stack>                                                                                                 
                      <LogoSelection selectedLogos={selectedLogos} setSelectedLogos={setSelectedLogos} />
                  </Stack>
              </Grid>
          </Grid> 
          <Stack justifyContent={"center"} alignItems={"center"} direction={"row"} spacing={2}>
            <FilePreviewAndSubmit programNameCertificate={programNameCertificate} programDateCertificate={programDateCertificate} signatures={signatures} selectedSignature={selectedSignature} mailerParent={mailerParent} mailerChild={mailerChild} selectedTemplate={template} categoryCertificate={categoryCertificate} campaignRadio={value} setIsCertificateGenerationClicked={setIsCertificateGenerationClicked} category={categoryName} subCategory={mailerParent} type={mailerChild} programname={programNameCertificate} setPptLink={setPptLink} setCertificateLoading={setCertificateLoading} selectedLogos={selectedLogos} />                        
          </Stack> 
        </>}       
      </Stack>
     </Stack>
    </Stack> : certificateType === 'pre-approved' ? <ApprovedTemplate outputFileName={pptxLink} backButton={'disabled'} certificateLoading={certificateLoading} /> : <DataDisplay categoryCertificate={categoryCertificate} mailerChild={mailerChild} mailerParent={mailerParent} programName={programNameCertificate} categoryName={categoryName} handleReset={handleReset} setIsMailGenerated={setIsMailGeneratedCertificate} setIsGenerationClicked={setIsCertificateGenerationClicked} setIsNavigatedToForm={setIsCertificateNavigatedToForm} />}
  </>;
};
export default CertificateForm;
